import axios from 'axios'
import { Message } from 'element-ui'
import { Loading } from 'element-ui'
import router from '../router'
import hostUri from '../utils/registered_address'

// const baseURL = 'https://api.uplus100.fit/api'
// const baseURL = process.env.NODE_ENV === 'development'
//   ? '/api'
//   : 'https://api.uplusai.info/api'
const baseURL = 'https://api.uplusai.info/api'
// const baseURL = 'https://api.uplus666.work/api'
// const baseURL = 'http://47.84.186.185:9090/api'
// const baseURL = 'http://192.168.0.101:9090/api'

export const baseUrl = baseURL

var loading = ''
let loadingCount = 0
let isFirstMessage = 1

const SUPPORT_VISITOR_STORAGE_KEY = 'X-Support-Visitor'
const LEGACY_SUPPORT_VISITOR_KEY = 'uplus_support_uid'
const SUPPORT_API_PATHS = [
    '/other/feedback',
    '/other/getFeedbackMsgList'
]

function isSupportApi(url = '') {
    return SUPPORT_API_PATHS.some(path =>
        url.toLowerCase().includes(path.toLowerCase())
    )
}

function getSupportVisitorId(data) {
    if (!data || typeof data !== 'object') return ''

    return data.visitorId ||
        (data.data && data.data.visitorId) ||
        ''
}

const instance = axios.create({
    baseURL,

    // baseURL: 'http://localhost:8081/api',
    // baseURL: 'http://192.168.0.105:9090/api',
    // baseURL: 'http://192.168.0.6:9090/api',
    // baseURL: 'http://localhost:8080/api',
    // baseURL: 'http://8.214.96.149:8899/api',

    timeout: 60000,

    headers: {
        'Content-Type': 'text/plain'

        // 'Content-Type': 'application/x-www-form-urlencoded',
        // 'Authorization':
        //   localStorage.getItem('token') != null
        //     ? localStorage.getItem('token')
        //     : ''
    },

    withCredentials: true

    // SameSite=None
})

function startLoading(config) {
    const skipLoading =
        config.params &&
        Number(config.params.requestTimes) === 10

    config.__showLoading = !skipLoading
    config.__loadingClosed = false

    if (skipLoading) return

    loadingCount++

    if (!loading) {
        loading = Loading.service({
            lock: false,
            text: '加载中……',
            background: 'rgba(0, 0, 0, 0.7)'
        })
    }

    config.__loadingTimer = setTimeout(() => {
        closeLoading(config)
    }, 10000)
}

function closeLoading(config) {
    if (
        !config ||
        !config.__showLoading ||
        config.__loadingClosed
    ) {
        return
    }

    config.__loadingClosed = true

    if (config.__loadingTimer) {
        clearTimeout(config.__loadingTimer)
    }

    loadingCount = Math.max(loadingCount - 1, 0)

    if (loadingCount === 0 && loading) {
        if (loading.close) {
            loading.close()
        }

        loading = ''
    }
}

function getResponseText(data) {
    if (data === null || data === undefined) {
        return ''
    }

    if (typeof data === 'string') {
        return data
    }

    try {
        return JSON.stringify(data)
    } catch (error) {
        return String(data)
    }
}

function isInvalidToken(data) {
    const text = getResponseText(data)
    const lowerText = text.toLowerCase()

    let code = ''

    if (data && typeof data === 'object') {
        code = String(
            data.code ||
            data.status ||
            data.errorCode ||
            ''
        ).toUpperCase()
    }

    const invalidCodes = [
        '401',
        'TOKEN_INVALID',
        'INVALID_TOKEN',
        'TOKEN_EXPIRED'
    ]

    return (
        invalidCodes.indexOf(code) !== -1 ||
        lowerText.indexOf('not invalid token') !== -1 ||
        lowerText.indexOf('invalid token') !== -1 ||
        lowerText.indexOf('token invalid') !== -1 ||
        lowerText.indexOf('token expired') !== -1 ||
        (
            (
                text.indexOf('非法請求') !== -1 ||
                text.indexOf('非法请求') !== -1
            ) &&
            (
                lowerText.indexOf('重新獲取token') !== -1 ||
                lowerText.indexOf('重新获取token') !== -1
            )
        )
    )
}

function safeReplace(path) {
    const currentPath =
        router.currentRoute &&
        router.currentRoute.path

    if (currentPath === path) return

    try {
        const navigation = router.replace(path)

        if (navigation && navigation.catch) {
            navigation.catch(error => {
                if (
                    error &&
                    error.name !== 'NavigationDuplicated'
                ) {
                    console.error('路由跳转失败：', error)
                }
            })
        }
    } catch (error) {
        console.error('路由跳转失败：', error)
    }
}

function clearLoginInfo() {
    window.localStorage.removeItem('token')
    window.localStorage.removeItem('userInfo')
}

function handleInvalidToken(data) {
    if (!isInvalidToken(data)) {
        return false
    }

    console.log('检测到 Token 已失效：', data)

    const hostname = window.location.hostname
    let registeredHost = ''

    try {
        registeredHost = hostUri.host_uri()
    } catch (error) {
        console.log('获取注册地址失败：', error)
    }

    console.log('当前域名：', hostname)
    console.log('配置域名：', registeredHost)

    clearLoginInfo()

    if (isFirstMessage === 1) {
        Message.warning('登录身份已过期，请重新登录！')
        isFirstMessage++
    }

    // 不再让域名判断阻止登录页跳转
    safeReplace('/login')

    return true
}

function createTokenError(data, response) {
    const error = new Error('TOKEN_INVALID')

    error.code = 'TOKEN_INVALID'
    error.data = data
    error.response = response

    return error
}

instance.interceptors.request.use(
    config => {
        const token = window.localStorage.getItem('token')

        config.headers = config.headers || {}
        config.params = config.params || {}

        if (token) {
            // Token 放到请求头
            config.headers.Authorization = token

            // Token 同时拼接到 URL
            const urlAlreadyHasToken =
                /(?:\?|&)token=/i.test(config.url || '')

            if (
                !urlAlreadyHasToken &&
                !config.params.token
            ) {
                config.params.token = token
            }
        } else if (isSupportApi(config.url)) {
            // 访客反馈只使用 X-Support-Visitor，禁止继续携带旧 Cookie。
            config.withCredentials = false
            window.localStorage.removeItem(LEGACY_SUPPORT_VISITOR_KEY)
            document.cookie =
                `${LEGACY_SUPPORT_VISITOR_KEY}=; Max-Age=0; Path=/; SameSite=Lax`

            const visitorId = window.localStorage.getItem(
                SUPPORT_VISITOR_STORAGE_KEY
            )

            if (visitorId) {
                config.headers[SUPPORT_VISITOR_STORAGE_KEY] = visitorId
            }
        }

        startLoading(config)

        // requestTimes 只用于控制 Loading，不传给后台
        if (config.params) {
            delete config.params.requestTimes
        }

        return config
    },

    error => {
        console.log('请求拦截错误：', error)

        closeLoading(error.config)

        return Promise.reject(error)
    }
)

instance.interceptors.response.use(
    response => {
        closeLoading(response.config)

        if (
            !window.localStorage.getItem('token') &&
            isSupportApi(response.config && response.config.url)
        ) {
            const visitorId = getSupportVisitorId(response.data)
            const storedVisitorId = window.localStorage.getItem(
                SUPPORT_VISITOR_STORAGE_KEY
            )

            if (visitorId && visitorId !== storedVisitorId) {
                window.localStorage.setItem(
                    SUPPORT_VISITOR_STORAGE_KEY,
                    visitorId
                )
            }
        }

        if (response.status === 500) {
            safeReplace('/Server_error')
        }

        if (response.status === 404) {
            safeReplace('/Not_found')
        }

        // 接口状态为 200，但内容提示 Token 非法
        if (handleInvalidToken(response.data)) {
            return Promise.reject(
                createTokenError(
                    response.data,
                    response
                )
            )
        }

        if (window.localStorage.getItem('token')) {
            isFirstMessage = 1
        }

        return response.data
    },

    error => {
        console.log('接口请求错误：', error)

        closeLoading(error.config)

        const response = error.response || {}
        const status = response.status
        const responseData = response.data

        // HTTP 401 或返回内容提示 Token 非法
        if (
            status === 401 ||
            isInvalidToken(responseData)
        ) {
            const tokenData =
                responseData ||
                {
                    code: 401,
                    message: 'not invalid token'
                }

            handleInvalidToken(tokenData)

            error.code = 'TOKEN_INVALID'

            return Promise.reject(error)
        }

        if (status === 500) {
            safeReplace('/Server_error')
        }

        if (status === 404) {
            safeReplace('/Not_found')
        }

        if (
            error.code === 'ECONNABORTED' ||
            (
                error.message &&
                error.message.indexOf('timeout') !== -1
            )
        ) {
            Message({
                message: '服务器繁忙',
                type: 'warning'
            })
        } else if (!status) {
            Message({
                message: '网络连接失败，请稍后重试',
                type: 'warning'
            })
        }

        return Promise.reject(error)
    }
)

function request(config) {
    return instance(config)
}

export default request
